import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppConfirmDialog } from '@v1/features/app/components/confirm-dialog/app-confirm-dialog';
import { AppNotificationToast } from '@v1/features/app/components/notification-toast/app-notification-toast';
import { AppUpdateMessage } from '@v1/features/app/components/update-message/app-update-message';

@Component({
  selector: 'app-root',
  template: `
    <app-configuration-update-message />
    <app-notification-toast />
    <app-confirm-dialog />
    <router-outlet />
  `,
  imports: [AppConfirmDialog, AppNotificationToast, AppUpdateMessage, RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
